import R from 'ramda'

const SPEED_THREAD_EXPIRY_DISPLAY_TYPE = 'Speed Thread Expired'
const SPEED_THREAD_EXPIRY_WIDGET_TYPE = 'SPEED_THREAD_EXPIRED'

const isSpeedThreadExpiryWidgetType = R.propEq(
  'type',
  SPEED_THREAD_EXPIRY_WIDGET_TYPE
)

const convertSpeedThreadExpiryToForm = R.applySpec({
  type: R.always(SPEED_THREAD_EXPIRY_DISPLAY_TYPE)
})

export { isSpeedThreadExpiryWidgetType, convertSpeedThreadExpiryToForm }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/speed-thread-expired.js